import apiClient from './apiClient';

export interface AuthUser {
  id: string;
  email: string;
  role: string;
  academy_id: string | null;
  first_name: string;
  last_name: string;
  avatar_url?: string;
  phone?: string;
  is_active: boolean;
  email_verified: boolean;
  created_at: string;
}

export interface AuthTokens {
  access_token: string;
  refresh_token: string;
  expires_at: string;
  token_type: string;
}

export interface AuthResponse {
  user: AuthUser;
  access_token: string;
  refresh_token: string;
  expires_at: string;
  token_type: string;
}

export interface RegisterPayload {
  email: string;
  password: string;
  role: 'player' | 'guardian' | 'coach' | 'director';
  academy_id: string;
  first_name: string;
  last_name: string;
  phone?: string;
  birth_date?: string;
  position?: string;
  country?: string;
  guardian_name?: string;
  guardian_phone?: string;
  guardian_email?: string;
  discount_code?: string;
}

export interface LoginPayload {
  email: string;
  password: string;
}

function persistAuth(data: AuthResponse) {
  localStorage.setItem('bts_access_token', data.access_token);
  localStorage.setItem('bts_refresh_token', data.refresh_token);
  localStorage.setItem('bts_user', JSON.stringify(data.user));
}

export const authApiService = {
  async register(payload: RegisterPayload): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/auth/register', payload, {
      skipAuth: true,
    });
    persistAuth(data);
    return data;
  },

  async login(payload: LoginPayload): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/auth/login', payload, {
      skipAuth: true,
    });
    persistAuth(data);
    return data;
  },

  async logout(): Promise<void> {
    const refreshToken = localStorage.getItem('bts_refresh_token');
    if (refreshToken) {
      try {
        await apiClient.post('/auth/logout', { refresh_token: refreshToken });
      } catch {
        // Best-effort logout
      }
    }
    apiClient.clearTokens();
  },

  async getMe(): Promise<AuthUser> {
    const { data } = await apiClient.get<AuthUser>('/auth/me');
    return data;
  },

  async forgotPassword(email: string): Promise<void> {
    await apiClient.post('/auth/forgot-password', { email }, { skipAuth: true });
  },
};

export default authApiService;
